import { app } from '../../../../../app';
import { Controller } from './application-integration.controller';

app.component('companyManageApplicationIntegrationDevelopersIntegration', {
    bindings: {
        account: '<',
        application: '<',
        applicationHelpInfo: '<',
        credentials$: '<',
    },
    controller: Controller,
    templateUrl: require('./application-integration.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/integration-developers/integration/application-integration.component.js